import { Filters } from './Filters';
import { Table } from './Table';

export const ReviewedAdditionalPaymentsTable = () => {
  return (
    <>
      <Filters />
      <Table />
    </>
  );
};
